import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-background flex flex-col" }
const _hoisted_2 = { class: "flex-grow container mx-auto px-4 py-8" }
const _hoisted_3 = ["innerHTML"]

import { Card, CardHeader, CardContent } from '@/components/ui/card'
import { ScrollArea } from '@/components/ui/scroll-area'
import { useTenant } from '@/composables/useTenant';


export default /*@__PURE__*/_defineComponent({
  __name: 'FaqView',
  setup(__props) {

const { tenant } = useTenant()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("header", { class: "" }, [
      _createElementVNode("div", { class: "container mx-auto px-4 py-6" }, [
        _createElementVNode("h1", { class: "text-[1.1rem] font-bold text-foreground text-center" }, "Perguntas frequentes")
      ])
    ], -1)),
    _createElementVNode("main", _hoisted_2, [
      _createVNode(_unref(Card), { class: "max-w-3xl mx-auto" }, {
        default: _withCtx(() => [
          _createVNode(_unref(CardHeader)),
          _createVNode(_unref(CardContent), null, {
            default: _withCtx(() => [
              _createVNode(_unref(ScrollArea), { class: "h-[60vh] pr-4" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "space-y-4 text-muted-foreground",
                    innerHTML: _unref(tenant).faq
                  }, null, 8, _hoisted_3)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})